const PageHeader = ({ title, description, children, className = "", showDescription = true }) => {
  return (
    <div className={`mb-4 sm:mb-6 ${className}`}>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-xl sm:text-2xl font-semibold text-secondary">{title}</h1>

          {showDescription && description && <p className="text-sm text-light mt-1">{description}</p>}
        </div>

        {children && <div className="w-full sm:w-auto flex sm:justify-end">{children}</div>}
      </div>
    </div>
  );
};

export default PageHeader;
